/**
 * ModeBadge (web) — small color-coded pill indicating which mode opened a trade.
 *
 * Annie Mode Phase 8 (PR #152). Mirrors apps/mobile/src/components/ModeBadge.tsx
 * but renders as a native web element.
 *
 * Renders nothing when mode is unknown — manual positions or broker rows
 * without a matching aggregate don't get a fake badge.
 */

import React from 'react';
import { modePalettes, type ActiveMode } from '@trading-app/shared';

interface Props {
  mode: ActiveMode | null | undefined;
  variant?: 'default' | 'compact';
  className?: string;
}

export function ModeBadge({ mode, variant = 'default', className }: Props) {
  if (mode !== 'ERIC' && mode !== 'ANNIE') return null;
  const palette = modePalettes[mode];
  const label = variant === 'compact' ? palette.name.charAt(0).toUpperCase() : palette.name;

  return (
    <span
      role="img"
      aria-label={`${palette.name} mode`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold text-white ${className ?? ''}`}
      style={{ backgroundColor: palette.brandPrimary }}
    >
      {label}
    </span>
  );
}
